export default __webpack_public_path__ + "static/fachada-detalhe-8046a279c87473c2fb7ff391384cffe7.webp";